import React from "react";
import styled from "styled-components";
import { FiArrowUpRight, FiGithub } from "react-icons/fi";
import Project from "./Project";
import { projects } from "./projectData";

const Projects = () => (
  <Container id="projects" aria-labelledby="projects-heading">
    <Content>
      <Heading>
        <div>
          <Eyebrow>Selected projects</Eyebrow>
          <h2 id="projects-heading">Ideas turned<br /><span>into working software.</span></h2>
          <Introduction>A selection of web and mobile applications. Different challenges, connected by a love of building useful things.</Introduction>
        </div>
        <GithubLink href="https://github.com/ukalto" target="_blank" rel="noreferrer" aria-label="More on GitHub (new tab)"><FiGithub aria-hidden="true" />More on GitHub<FiArrowUpRight aria-hidden="true" /></GithubLink>
      </Heading>
      <ProjectCount><span>{String(projects.length).padStart(2, "0")} projects</span><span>Web applications · Mobile · Full stack</span></ProjectCount>
      <Grid>{projects.map((project, index) => <Project key={project.id} project={project} index={index} featured={index === 0} />)}</Grid>
    </Content>
  </Container>
);

export default Projects;

const Container = styled.section`
  padding: 3.5rem 1rem;
  color: #f2f7f4;
  background: radial-gradient(ellipse at 100% 0%, #244e40, transparent 50%), #142f27;
  @media (min-width: 600px) { padding: 5rem 5%; }
  @media (min-width: 1024px) { padding-block: 6rem; }
`;
const Content = styled.div`max-width: 1120px; margin-inline: auto;`;
const Heading = styled.div`
  display: flex; flex-direction: column; align-items: flex-start; gap: 1.5rem;
  h2 { font-size: clamp(1.9rem, 4vw, 3.25rem); font-weight: 500; line-height: 1.15; letter-spacing: -0.055em; }
  h2 span { color: #a6d9bc; }
  @media (min-width: 840px) { flex-direction: row; justify-content: space-between; align-items: flex-end; gap: 3rem; }
`;
const Eyebrow = styled.p`margin-bottom: 1.25rem; color: #9bc8b3; font-size: 0.7rem; font-weight: 600; letter-spacing: 0.15em; text-transform: uppercase;`;
const Introduction = styled.p`max-width: 52ch; margin-top: 1.25rem; color: #c1d2c9; font-size: 0.9rem; line-height: 1.85;`;
const GithubLink = styled.a`
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; gap: 0.65rem;
  min-height: 48px; padding: 0.75rem 1.1rem; border: 1px solid #779e885c; border-radius: 999px;
  color: #d1f3df; background: #ffffff06; font-size: 0.75rem; text-decoration: none;
  &:hover { background: #ffffff10; }
  &:focus-visible { outline: 2px solid #a6d9bc; outline-offset: 4px; }
`;
const ProjectCount = styled.div`
  display: flex; flex-wrap: wrap; justify-content: space-between; gap: 0.5rem 1rem;
  margin-top: 2.5rem; padding-top: 1.25rem; border-top: 1px solid #bedfcc29;
  color: #a6c2b3; font-size: 0.65rem; line-height: 1.7;
`;
const Grid = styled.div`
  display: grid; grid-template-columns: minmax(0, 1fr); gap: 1.25rem; margin-top: 1.25rem;
  @media (min-width: 700px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
`;
